import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dashboardActions from "../../redux/actions/dashboardActions";
import * as i18nActions from "../../redux/actions/i18nActions";
import * as deviceActions from "../../redux/actions/deviceActions";
import { translate } from "../../utils/i18n";

import { HighChartsComp, DevicesSelectorComp, BlockPlaceholder } from ".";
import { Card, CardBody, Col, Row } from "reactstrap";

const HighChartsContainerComp = props => {
  return (
    <Card className="animated fadeIn">
      <CardBody>
        <DevicesSelectorComp />
        <Row>
          <Col className="pt-2">
            {props.isFetchingDeviceData ? (
              <React.Fragment>
                <BlockPlaceholder height={"500"} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                {props.isNoDeviceSelected ? <BlockPlaceholder height={"500"} message={translate("NoDeviceSelected")} /> : <HighChartsComp />}
              </React.Fragment>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = state => ({
  isFetchingDeviceData: state.devicesReducer.isFetchingDeviceData,
  language: state.i18nReducer.language,
  isNoDeviceSelected: state.devicesReducer.isNoDeviceSelected
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...i18nActions, ...dashboardActions, ...deviceActions }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HighChartsContainerComp);
